// components/BackgroundParticles.jsx
import { Canvas, useFrame } from '@react-three/fiber';
import { useMemo, useRef } from 'react';

function gaussianRandom(mean = 0, sigma = 1) {
    const u1 = Math.random();
    const u2 = Math.random();
    const z0 = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
    return z0 * sigma + mean;
}

function Particles() {
    const mesh = useRef();
    const count = 10000;

    const positions = useMemo(() => {
        const arr = new Float32Array(count * 3);
        for (let i = 0; i < count; i++) {
            arr[i * 3]     = gaussianRandom(0, 4);
            arr[i * 3 + 1] = gaussianRandom(0, 4);
            arr[i * 3 + 2] = gaussianRandom(0, 3);
        }
        return arr;
    }, []);

    useFrame(({ mouse }) => {
        if (mesh.current) {
            mesh.current.rotation.x += 0.0005;
            mesh.current.rotation.y += 0.001;
        }
    });

    return (
        <points ref={mesh}>
            <bufferGeometry>
                <bufferAttribute
                    attach="attributes-position"
                    count={positions.length / 3}
                    array={positions}
                    itemSize={3}
                />
            </bufferGeometry>
            <pointsMaterial
                size={0.018}
                color="black"
                sizeAttenuation
                transparent
                opacity={0.25}
            />
        </points>
    );
}

export default function BackgroundParticles() {
    return (
        <Canvas
            camera={{ position: [0, 0, 5], fov: 75 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 0,
                width: '100vw',
                height: '100vh',
            }}
        >
            <Particles />
        </Canvas>
    );
}
